import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SearchResults from "./pages/SearchResults";
import BookingDetails from "./pages/BookingDetails";
import BookingSummary from "./pages/BookingSummary";
import SearchBooking from "./pages/SearchBooking";
import Footer from "./components/Footer";
import { config } from "./config";
import AboutUs from "./pages/AboutUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import BookingConfirmation from "./pages/BookingConfirmation";
import ManageBooking from "./pages/ManageBooking";

function App() {
  useEffect(() => {
    // Update document title
    document.title = config.siteName;

    // Update favicon
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = config.logoSrc;
    }

    // Update apple touch icon
    const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (appleIcon) {
      appleIcon.href = config.logoSrc;
    }
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/flights/:route" element={<SearchResults />} />
            <Route path="/booking/details" element={<BookingDetails />} />
            <Route path="/booking/summary" element={<BookingSummary />} />
            <Route
              path="/booking/confirmation"
              element={<BookingConfirmation />}
            />
            <Route path="/my/manage-booking" element={<SearchBooking />} />
            <Route path="/my/booking/:bookingRef" element={<ManageBooking />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
